import React, { useState } from 'react';
import Icon from '../Icon';

const FAQ = [
  { q: 'Will checking eligibility cost me anything?',
    a: "No. The eligibility check is completely free. If you choose to have us help with your application, we only charge a fee if you're approved — never upfront." },
  { q: 'Do you need my Social Security number to check?',
    a: "Not at this stage. We only ask for state, situation, and contact info. Your SSN is only required later if you formally apply, and it's transmitted directly to the state agency through HIPAA-compliant channels." },
  { q: 'How long does approval take?',
    a: "It varies by state, but the median time from completed application to first payment is 14 days. Some states approve in as little as 7 days; others take 30+." },
  { q: "What if I'm not eligible right now?",
    a: "Your advocate will tell you exactly why and what (if anything) would change that. Many families become eligible after a small change in the recipient's enrollment or after a formal needs assessment." },
  { q: 'Is my information private?',
    a: "Yes. We're HIPAA-compliant, use 256-bit SSL, never sell your information, and only share details with state agencies you authorize." },
];

const FaqItem = ({ q, a, open, onToggle }) => (
  <div className={`faq-item ${open ? 'open' : ''}`}>
    <button className="faq-q" onClick={onToggle} aria-expanded={open}>
      <span>{q}</span>
      <span className="chev">
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none">
          <path d="M1 1L7 7L13 1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </span>
    </button>
    {open && <div className="faq-a">{a}</div>}
  </div>
);

const EligibilityFAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section className="elig-faq">
      <div className="container">
        <div className="elig-faq-grid">
          <div>
            <span className="eyebrow">Common questions</span>
            <h2 style={{ marginTop: 14 }}>Answers to what families ask most.</h2>
            <p className="lede">
              Don't see your question? Our care advocates answer the phone in under 2 minutes.
            </p>
            <div className="help-card">
              <div className="text">
              </div>
            </div>
          </div>
          <div className="elig-faq-list">
            {FAQ.map((f, i) => (
              <FaqItem key={i} q={f.q} a={f.a}
                open={open === i}
                onToggle={() => setOpen(open === i ? -1 : i)} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EligibilityFAQ;
